<template>
  <div id="AddTypeName" class="well" style="padding: 0 1em">
    <div>
      <button
        href="#"
        @click.prevent="close()"
        class="btn btn-outline-secondary"
        type="button"
        style="font-size: 14px"
      >
        回競賽種類名稱列表
      </button>
    </div>
    <div class="form-group">
      <table class="table" style="width: 100%; align: left">
        <tbody style="width: 70%; align: left">
         <tr class="table-success" align="left">
            <td>
              <div>
                <span class="red_star">＊</span>競賽種類名稱:
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData.TypeName"
                  ref="inputData.TypeName"
                  placeholder="請輸入競賽種類名稱"
                />
              </div>
            </td>
          </tr>

        </tbody>
      </table>
    </div>

    <div style="text-align: center">
      <button
        href="#"
        @click.prevent="AddTypeName()"
        class="btn btn-outline-success"
        type="button"
        style="font-size: 14px"
      >
        送出
      </button>
    </div>
  </div>
</template>

<script>
import * as tools from '../tool'
import Ckeditor from 'vue-ckeditor2'
export default {
  name: 'AddTypeName',
  components: {
    Ckeditor
  },
  data () {
    return {
      mode: true,
      file: [{ name: '', RowId: '' }],
      inputFlag: false,
      linkText: null,
      total: 0,
      isIE: false,
      getTeacherData: null,
      inputData: {
        TypeName: null
      },
      currentPage: 1,
      cid: '',
      pageSize: 10,

      config: {
        toolbar: [
          ['Source', '-', 'Preview', '-', 'Templates'],
          [
            'Cut',
            'Copy',
            'Paste',
            'PasteText',
            'PasteFromWord',
            '-',
            'Undo',
            'Redo'
          ],
          ['Find', 'Replace', '-', 'SelectAll', '-', ''],
          [
            'Bold',
            'Italic',
            'Underline',
            'Strike',
            'Subscript',
            'Superscript',
            '-',
            'CopyFormatting',
            'RemoveFormat'
          ],
          [
            'NumberedList',
            'BulletedList',
            '-',
            'Outdent',
            'Indent',
            '-',
            'Blockquote',
            'CreateDiv',
            '-',
            'JustifyLeft',
            'JustifyCenter',
            'JustifyRight',
            'JustifyBlock',
            '-',
            'BidiLtr',
            'BidiRtl',
            'Language'
          ],
          ['Link', 'Unlink', 'Anchor'],
          [
            'Image',
            'Table',
            'HorizontalRule',
            'Smiley',
            'SpecialChar',
            'PageBreak',
            'Iframe'
          ],
          ['Styles', 'Format', 'Font', 'FontSize'],
          ['TextColor', 'BGColor'],
          ['Maximize', 'ShowBlocks'],
          ['About']
        ]
      }
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    }
  },
  methods: {

    empty (str) {
      if (
        typeof str === 'undefined' ||
        !str ||
        str.length === 0 ||
        str === '' ||
        !/[^\s]/.test(str) ||
        /^\s*$/.test(str)
      ) {
        return true
      } else {
        return false
      }
    },

    checkInput () {
      this.inputFlag = false
      if (this.empty(this.inputData.TypeName)) {
        alert('請輸入競賽種類名稱')

        this.inputFlag = true
      }
    },
    AddTypeName () {
      this.checkInput()
      const vm = this
      if (vm.inputFlag != true) {
        this.$http
          .put('./WebApi/EconomicDisadvantage/AddTypeName/', this.inputData)
          .then((response) => {
            if (response.data > 0) {
              tools.showAlert(vm, 'success', '增加競賽種類名稱成功')
              this.close()
            } else {
              tools.showAlert(vm, 'danger', '對不起,增加競賽種類名稱失敗')
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
          })
      }
    },

    close () {
      this.$emit('hideModal')
    }
  },
  created () {
    console.log('======created AddTypeNameView =====')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
